import axios from "axios";
import React, { useState, useEffect } from "react";
import { Config } from "../../../../../Config";
import LogModal from "./Components/LogModal";
import ScreenOverlay from "./Components/ScreenOverlay";

const FinalStage = (props) => {
  const [TransferStarted, setTransferStarted] = useState(false);
  const [TransferIsDone, setTransferIsDone] = useState();
  const [TransferSuccessful, setTransferSuccessful] = useState();
  const [MappingIsDone, setMappingIsDone] = useState(false);
  const [MappingLogs, setMappingLogs] = useState([]);
  const [StagingLogs, setStagingLogs] = useState([]);
  const [FinalLogIsOpen, setFinalLogIsOpen] = useState(false);
  const [InitialTabsCheckIsDone, setInitialTabsCheckIsDone] = useState(false);

  var statusCheckTimeout;

  useEffect(() => {
    if (window.localStorage.getItem("TransferInProgress") === "1") {
      clearInterval(statusCheckTimeout);
      getStatus(false);
      statusCheckTimeout = setInterval(getStatus, 7000);
      setTransferStarted(true);
    } else {
      setTransferStarted(false);
    }
    checkMandatoryTabsStatus();
  }, []);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const getStatus = (IsDone) => {
    if (!IsDone) {
      getMappingLogs();
    } else {
      clearInterval(statusCheckTimeout);
      endTransferSuccessfully();
    }
  };

  const endTransferSuccessfully = () => {
    setTransferIsDone(true);
    setTransferStarted(false);
    setTransferSuccessful(true);
    window.localStorage.setItem("TransferInProgress", 0);
    window.localStorage.setItem("UnfinishedTransfer", 1);
    window.localStorage.setItem("WasFailed", 0);
    clearInterval(statusCheckTimeout);
  };
  const failWithError = () => {
    window.localStorage.setItem("TransferInProgress", 0);
    window.localStorage.setItem("UnfinishedTransfer", 1);
    window.localStorage.setItem("WasFailed", 1);
    setTransferSuccessful(false);
    setTransferIsDone(true);
    setTransferStarted(false);
    clearInterval(statusCheckTimeout);
  };
  const getMappingLogs = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.DataImportURL +
        "/api/mapping-process/view-log/mapping",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        if (Res.data.status === "IN_PROGRESS") {
          if (
            Res.data.details.length > 0 &&
            Res.data.details[0].status === "STOPPED"
          ) {
            failWithError();
          }
        }
        if (Res.data.status === "COMPLETED") {
          getDistributingLogs();
          setMappingIsDone(true);
        }
        if (!MappingIsDone) {
          setMappingLogs(Res.data.details);
        }
      })
      .catch((Err) => {
        console.log(Err);
        failWithError();
      });
  };

  const getDistributingLogs = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.DataImportURL +
        "/api/mapping-process/view-log/distributing",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setStagingLogs(Res.data.details);
        if (Res.data.status === "COMPLETED") {
          endTransferSuccessfully();
        }
      })
      .catch((Err) => {
        console.log(Err);
        failWithError();
      });
  };

  const checkMandatoryTabsStatus = () => {
    if (
      window.localStorage.getItem("PosFilesUploaded") === "1" &&
      window.localStorage.getItem("EmpFilesUploaded") === "1"
    ) {
      if (window.localStorage.getItem("UnfinishedTransfer") === "1") {
        setTransferIsDone(true);
        getMappingLogs();
        if (window.localStorage.getItem("WasFailed") === "1") {
          setTransferSuccessful(false);
        } else {
          setTransferSuccessful(true);
        }
      }
      setInitialTabsCheckIsDone(true);
    } else {
      setInitialTabsCheckIsDone(true);
    }
  };

  const triggerTransfer = () => {
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.DataImportURL +
        "/api/mapping-process/execute",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        generateSkillsFor: props.GenerateSkillsFor,
        generatePositionDescriptionFor: props.GenerateJobDescFor,
        generateProjectDescriptionFor: props.GenerateProjectDescFor,
        generateActivityDescriptionFor: props.GenerateActivityDescFor,
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        window.localStorage.setItem("TransferInProgress", 1); // 1:true, 0:false
        setTransferStarted(true);
        getStatus();
        statusCheckTimeout = setInterval(getStatus, 7000);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const startOver = () => {
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.DataImportURL +
        "/api/mapping-process/start-over",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
    };
    axios(Req)
      .then(() => {
        window.localStorage.removeItem("UnfinishedTransfer");
        window.localStorage.removeItem("WasFailed");
        window.localStorage.removeItem("PosFilesUploaded");
        window.localStorage.removeItem("EmpFilesUploaded");
        window.location.assign("/home/dataImport");
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };

  const retryTransfer = () => {
    setTransferIsDone(false);
    triggerTransfer();
  };

  return (
    <>
      {InitialTabsCheckIsDone ? (
        <>
          {TransferIsDone && !TransferStarted ? (
            <div className="simple-form">
              {FinalLogIsOpen ? (
                <LogModal
                  LogData={StagingLogs.length === 0 ? MappingLogs : StagingLogs}
                  StageName={StagingLogs.length === 0 ? " Staging " : " Base "}
                  Close={() => setFinalLogIsOpen(false)}
                  LangData={props.LangData}
                />
              ) : null}
              <section className="form-head">
                <h1>{translateText("staging_and_base_transfer")}</h1>
              </section>
              <div className="form-body relative-body">
                {TransferSuccessful ? (
                  <div className="transfer-report successful">
                    <i className="feather-check-circle"></i>
                    <p className="report-message">
                      {translateText("data_import_staging_and_base_success")}
                    </p>
                    <p className="report-date">
                      {" "}
                      {MappingLogs.length > 0 && MappingLogs[0].endTime
                        ? new Date(MappingLogs[0].endTime).toDateString()
                        : null}{" "}
                    </p>
                    <section className="actions">
                      <button
                        onClick={() => setFinalLogIsOpen(true)}
                        className="report-action"
                      >
                        {translateText("view_logs")}
                      </button>
                      <button
                        onClick={() => startOver()}
                        className="primary-action"
                      >
                        {translateText("start_over")}
                      </button>
                    </section>
                  </div>
                ) : (
                  <div className="transfer-report failed">
                    <i className="feather-x-circle"></i>
                    <p className="report-message">
                      {translateText("something_went_wrong")}.
                    </p>
                    <p className="report-date">
                      {" "}
                      {MappingLogs.length > 0 && MappingLogs[0].endTime
                        ? new Date(MappingLogs[0].endTime).toDateString()
                        : null}{" "}
                    </p>
                    <section className="actions">
                      <button
                        onClick={() => setFinalLogIsOpen(true)}
                        className="report-action"
                      >
                        {translateText("view_logs")}
                      </button>
                      <button
                        onClick={() => retryTransfer()}
                        className="primary-action"
                      >
                        {translateText("retry")}
                      </button>
                    </section>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div className="simple-form">
              {TransferStarted ? (
                <ScreenOverlay
                  StagingLogs={MappingLogs}
                  BaseLogs={StagingLogs}
                  LangData={props.LangData}
                />
              ) : null}
              <section className="form-head">
                <h1>{translateText("staging_and_base_transfer")}</h1>
              </section>
              <div className="form-body">
                {props.EmpFilesUploaded && props.PosFilesUploaded ? (
                  <p className="final-stage-info">
                    {translateText("data_import_files_uploaded_info")}
                    <br />{" "}
                    {translateText("data_import_you_can_start_staging_info")}.
                  </p>
                ) : (
                  <React.Fragment>
                    {window.localStorage.getItem("EmpFilesUploaded") === "0" ? (
                      <p className="final-stage-info">
                        {translateText("data_import_employees_tab_error")}
                      </p>
                    ) : null}
                    {window.localStorage.getItem("PosFilesUploaded") === "0" ||
                    window.localStorage.getItem("PosFilesUploaded") === null ? (
                      <p className="final-stage-info">
                        {translateText("data_import_positions_tab_error")}
                      </p>
                    ) : null}
                  </React.Fragment>
                )}
                {props.EmpFilesUploaded && props.PosFilesUploaded ? (
                  <p className="final-stage-warning">
                    {translateText("data_import_do_not_leave_warning")}
                  </p>
                ) : null}
                {props.EmpFilesUploaded && props.PosFilesUploaded ? (
                  <button
                    onClick={() => triggerTransfer()}
                    className="start-transfer"
                  >
                    {translateText("staging_and_base_transfer")}
                  </button>
                ) : (
                  <button
                    onClick={() => null}
                    className="start-transfer disabled"
                  >
                    {translateText("staging_and_base_transfer")}
                  </button>
                )}
              </div>
            </div>
          )}
        </>
      ) : null}
    </>
  );
};
export default FinalStage;
